import React, { useState, useEffect } from "react";
import { SiMinutemailer } from "react-icons/si";
import { SlSocialLinkedin } from "react-icons/sl";
import { VscGithub } from "react-icons/vsc";
import { ImDownload } from "react-icons/im";
import { useTranslation } from "react-i18next";

import Animate from "@charlesvien/react-animatecss";
import ContactStyles from "./Contact.module.scss";

import Picture from "../../assets/images/Picture.jpg";
import CV from "../../assets/CJH - CV 2026.pdf";

import ProfileCard from "../ProfileCard/ProfileCard";

const Contact = ({ scrollToHome }) => {
  const { t } = useTranslation();

  const [iconsTitles, setTitles] = useState("");
  const [visible, setVisible] = useState(false);
  const [iconsLinks, setIconsLinks] = useState("");
  const [iconDesc, setIconDesc] = useState(null);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setIsTablet(true);
      } else {
        setIsTablet(false);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleMouseOver = (iconsTitles) => {
    if (iconsTitles === "Mail") {
      setIconsLinks(t("contact.mail.link"));
      setIconDesc(t("contact.mail.description"));
    }
    if (iconsTitles === "LinkedIn") {
      setIconsLinks(t("contact.linkedin.link"));
      setIconDesc(t("contact.linkedin.description"));
    }
    if (iconsTitles === "Github") {
      setIconsLinks(t("contact.github.link"));
      setIconDesc(t("contact.github.description"));
    }
    if (iconsTitles === "CV") {
      setIconsLinks(t("contact.cv.link"));
      setIconDesc(t("contact.cv.description"));
    }
    setTitles(iconsTitles);
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setTitles("");
    setIconDesc("");
    setVisible(false);
  };

  return (
    <>
      <div className={ContactStyles.container}>
        <div className={ContactStyles.title}>{t("contact.title")}</div>
        <div className={ContactStyles.content}>
          {isTablet ? (
            <div className={ContactStyles.rightTabletMobile}>
              <div className={ContactStyles.icons}>
                <div className={ContactStyles.iconsTabletMobile}>
                  <a
                    href="mailto:jochong27@gmail.com"
                    aria-label="Send an email"
                  >
                    <SiMinutemailer size="2.5em" />
                  </a>
                  {t("contact.mail.description")}
                </div>
                <div className={ContactStyles.iconsTabletMobile}>
                  <a
                    href="https://www.linkedin.com/in/jonghoa-chong/"
                    aria-label="Go to linkedin"
                  >
                    <SlSocialLinkedin size="2.5em" />
                  </a>
                  {t("contact.linkedin.description")}
                </div>
                <div className={ContactStyles.iconsTabletMobile}>
                  <a
                    href="https://github.com/JongCHONG"
                    aria-label="Go to github"
                  >
                    <VscGithub size="2.5em" />
                  </a>
                  {t("contact.github.description")}
                </div>
                <div className={ContactStyles.iconsTabletMobile}>
                  <a href={CV} download aria-label="Download CV">
                    <ImDownload size="2.5em" />
                  </a>
                  {t("contact.cv.link")}
                </div>
              </div>
            </div>
          ) : (
            <div className={ContactStyles.rightDesktop}>
              <div className={ContactStyles.picture}>
                <ProfileCard
                  name="Jong H. CHONG"
                  title="Software Engineer"
                  handle="javicodes"
                  status="Online"
                  contactText="Contact Me"
                  avatarUrl={Picture}
                  showUserInfo={false}
                  enableTilt={true}
                />
              </div>
              <div className={ContactStyles.rightDesktopIcons}>
                <Animate
                  animationIn="fadeInLeft"
                  animationOut="fadeOutRight"
                  inDuration={1000}
                  outDuration={1000}
                  visible={visible}
                >
                  <div className={ContactStyles.iconsTitles}>{iconsTitles}</div>
                </Animate>
                <div className={ContactStyles.icons}>
                  <a
                    href="mailto:jochong27@gmail.com"
                    aria-label="Send an email"
                  >
                    <SiMinutemailer
                      size="3em"
                      onMouseOver={() => handleMouseOver("Mail")}
                      onMouseLeave={handleMouseLeave}
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/jonghoa-chong/"
                    aria-label="Go to linkedin"
                  >
                    <SlSocialLinkedin
                      size="2.5em"
                      onMouseOver={() => handleMouseOver("LinkedIn")}
                      onMouseLeave={handleMouseLeave}
                    />
                  </a>
                  <a
                    href="https://github.com/JongCHONG"
                    aria-label="Go to github"
                  >
                    <VscGithub
                      size="2.5em"
                      onMouseOver={() => handleMouseOver("Github")}
                      onMouseLeave={handleMouseLeave}
                    />
                  </a>
                  <a href={CV} download aria-label="Download CV">
                    <ImDownload
                      size="2.5em"
                      onMouseOver={() => handleMouseOver("CV")}
                      onMouseLeave={handleMouseLeave}
                    />
                  </a>
                  <Animate
                    animationIn="fadeInDown"
                    animationOut="fadeOutDown"
                    inDuration={1000}
                    outDuration={1000}
                    visible={visible}
                  >
                    {visible && iconsLinks}
                  </Animate>
                </div>
                <Animate
                  animationIn="fadeInUp"
                  animationOut="fadeOutDown"
                  inDuration={1000}
                  outDuration={1000}
                  visible={visible}
                >
                  <div className={ContactStyles.iconsDesc}>
                    {visible && iconDesc}
                  </div>
                </Animate>
              </div>
            </div>
          )}
        </div>
        <div className={ContactStyles.version}>
          v5 - © 2025 - _/0[\]6[-][]|-\&nbsp;&nbsp;&nbsp;<b>[#[]/\/6</b>
        </div>
        <div className={ContactStyles.scrollUp}>
          <div className={ContactStyles.scrollToHome} onClick={scrollToHome} />
        </div>
      </div>
    </>
  );
};

export default Contact;
